import styled from 'styled-components';
import { ReactComponent as ArrowIcon } from '@elementary/common-ui/assets/arrow-big.svg';
import { Flex, FlexColumn } from '@elementary/common-ui/components';
import { capitalize } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { ReviewChange } from './types';

const ChangeWrapper = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray7};
  padding: 8px 16px;
  border-radius: 8px;
  align-items: center;
  width: 290px;
  min-height: 60px;
  overflow-y: hidden;
`;

type Props = {
  changes: ReviewChange<any>[];
};

const ChangesReviewList = ({ changes }: Props) => (
  <FlexColumn sx={{ gap: 2 }}>
    {changes.map((change, index) => (
      <Flex key={index} sx={{ gap: 2, alignItems: 'center' }}>
        <Typography sx={{ fontWeight: 'bold', width: '100px' }}>
          {capitalize(change.title)}
        </Typography>
        <ChangeWrapper>
          {change.renderer?.(change.originalValue) || change.originalValue}
        </ChangeWrapper>
        <ArrowIcon />
        <ChangeWrapper>
          {change.renderer?.(change.updatedValue) || change.updatedValue}
        </ChangeWrapper>
      </Flex>
    ))}
  </FlexColumn>
);

export default ChangesReviewList;
